import {
  IFormEventRecord,
  IUserInfo,
  TEMPLATES,
} from "@home-health-notify/domain";
import { JsonForms } from "@jsonforms/react";
import {
  ChatContext,
  reorderUiSchema,
  templatesInfoMap,
  useFetchTemplate,
} from "hhn-commons";
import { useContext, useMemo } from "react";
import viewRenderers from "../../message/templates/viewRenderers";
import { TemplateFormTitle, TimelineItemDetails } from "./CareTimeline.style";

const CareTimelineFormItem = ({
  timelineItem,
  userData,
}: {
  timelineItem: IFormEventRecord;
  userData: IUserInfo;
}) => {
  const timelineData = timelineItem.data;
  const templateKey = timelineData.templateType as keyof typeof TEMPLATES;
  const { chat } = useContext(ChatContext);
  useFetchTemplate(templateKey, chat);
  const template = chat && chat.getTemplateByKey(templateKey);

  const selectedTemplateInfo = useMemo(() => {
    return {
      ...templatesInfoMap[templateKey],

      form: template,
    };
  }, [template, templateKey]);

  const reorderedUiSchema = useMemo(() => {
    return reorderUiSchema(selectedTemplateInfo);
  }, [selectedTemplateInfo]);
  let formData = undefined;
  if (selectedTemplateInfo?.form?.payloadToFormDataHandler) {
    formData = selectedTemplateInfo?.form?.payloadToFormDataHandler(
      { form: timelineData },
      selectedTemplateInfo?.form,
    );
  }

  return (
    <TimelineItemDetails>
      <TemplateFormTitle>
        {userData.title} filled {selectedTemplateInfo?.label} form details:
      </TemplateFormTitle>
      {selectedTemplateInfo?.form && formData && reorderedUiSchema && (
        <JsonForms
          schema={selectedTemplateInfo?.form.schema}
          uischema={reorderedUiSchema}
          data={formData}
          renderers={viewRenderers}
        />
      )}
    </TimelineItemDetails>
  );
};

export default CareTimelineFormItem;
